import ApplicationAdapter from "./application";

export default class LoadBalancerCertificateAdapter extends ApplicationAdapter {
  urlForCreateRecord() {
    return `${this.apiBaseUri}/loadbalancer/addcertificate`;
  }

  urlForDeleteRecord(id, _, snapshot) {
    return `${this.apiBaseUri}/loadbalancer/removecertificate?certificatename=${id}&loadbalancerid=${snapshot.belongsTo("loadBalancer").id}`;
  }
}
